import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvitationService {

  private apiUrl = environment.webSocketApiUrl + '/api/invitations';
  
  constructor(private http: HttpClient) {}

  sendInvitation(invitation: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/send`, invitation, { });
  }

  acceptInvitation(invitation: any): Observable<string> {
    return this.http.post(`${this.apiUrl}/accept`, invitation, { responseType: 'text' });
  }

  fetchUnread(userId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/unread/${userId}`);
  }

  fetchUnreadCount(userId: number): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}/unread-count/${userId}`);
  }

  markAsRead(notificationId: number): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/mark-as-read/${notificationId}`, {});
  }
}
